import { _APIHandler } from "../utils/helper";

let baseUrl = "users";
export const fetchUsers = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const fetchUserLists = () => _APIHandler.get(`${baseUrl}/lists`);
export const fetchUser = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const createUser = (data) => _APIHandler.post(`${baseUrl}`, data,);
export const updateUser = (id, data) => _APIHandler.put(`${baseUrl}/${id}`, data);
export const updateUserStatus = (id, data) => _APIHandler.put(`${baseUrl}/${id}/update_user_status`, data);
export const deleteUser = (id) => _APIHandler.delete(`${baseUrl}/${id}`);